/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";

import TabNewCompany from "./TabNewCompany";

import "./style.css";

export default function EditCompany({ history }) {
  const [companyData, setCompanyData] = useState({});
  const [loading, setLoading] = useState(false);

  return (
    <>
      {!loading ? (
        <>
          <TabNewCompany companyData={companyData} history={history} />
        </>
      ) : (
        
        <div className="area-loading-edit-company">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
